import {CustomCode} from "../common.model";

export class HRParamType extends CustomCode {

  private static _registered = new Map<string, HRParamType>();

  static CATEGORY = new HRParamType('CATEGORY');
  static CONSEQUENCE = new HRParamType('CONSEQUENCE');
  static GRIEVANCE_TYPE = new HRParamType('GRIEVANCE_TYPE');
  static CERTIFICATE_CATEGORY = new HRParamType("CERTIFICATE_CATEGORY");
  static TRAINING_ORGANISATION = new HRParamType("TRAINING_ORGANISATION");


  static SECURITY = new HRParamType('SECURITY');
  static SECTION = new HRParamType('SECTION');

  static ALL = Array.from(HRParamType._registered.values());

  constructor(code: string) {
    super(code);
    HRParamType._registered.set(code, this);
  }


  public toString(): string {
    return this.code;
  }


  toTranslateKey():string{
    return 'HR_PARAM_TYPE_' + this.code;
  }


  static retrieveFromCode(code: string): HRParamType {
    const res = HRParamType._registered.get(code);
    if (!res) {
      console.log('Hmmm HRParamType can\'t find ' + code);
    }
    return res;
  }
}
